import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var UnlockIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/_jsx("path", {
    d: "M17,10H9a1.09,1.09,0,0,1,0-.18V7a3,3,0,0,1,6,0h2A5,5,0,0,0,7,7v3a2.08,2.08,0,0,0-2,2.08v7.84A2.08,2.08,0,0,0,7.08,22h9.84A2.08,2.08,0,0,0,19,19.92V12.08A2.08,2.08,0,0,0,17,10Zm-4.2,5.76V18.2a.8.8,0,1,1-1.6,0V15.76a1.48,1.48,0,0,1-.7-1.26,1.5,1.5,0,0,1,3,0A1.48,1.48,0,0,1,12.8,15.76Z"
  })]
}), 'UnlockIcon');